<template>
    <div class="picCarousel-model" v-if="isShow" @click="closeCarousel">
        <div v-swiper:mySwiper="swiperOptions" class="swiper-container swiper-container-horizontal">
            <!-- Slides wrapper -->
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in imgList" :key="index">
                    <div class="reviewPicture-modelImg">
                        <img :src="item" alt="详情图片" class="">
                    </div>
                </div>
            </div>
            <!-- 左右按钮 -->

            <!-- 分页 -->
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
    import { directive } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    export default {
        name: 'PicCarousel',
        directives: {
            swiper: directive
        },
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            imgList: {
                type: Array,
                default: function () {}
            },
            activeIndex: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                swiperOptions: {
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination'
                    }
                }
            }
        },
        updated () {
            if (!this.mySwiper.destroyed) {
                this.mySwiper.slideTo(this.activeIndex + 1, 0, false)
            }
        },
        methods: {
            closeCarousel () {
                this.$emit('on-close')
            }
        }
    }
</script>

<style lang="less">
    /**** picCarousel ****/
    .picCarousel-model{
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background-color:rgba(0,0,0,1);
        z-index:11;
        .swiper-container {
            height:100%;
            .swiper-slide {
                padding:0 12px;
            }
            .swiper-pagination {
                width: 100%;
                height: 19px;
                line-height: 19px;
                left: 0;
                bottom: 54px;
                padding: 0 10px;
                background-color: rgba(0,0,0,.4);
                border-radius: 12px;
                text-align: center;
            }
            .swiper-pagination-bullet {
                width:10px;
                height:10px;
                margin: 0 5px;
                opacity:1;
                filter:alpha(opacity=100);
                background-color:#fff;
            }
            .swiper-pagination-bullet-active {
                background-color: #febd11;
                width: 20px;
                height: 10px;
                border-radius: 10px;
            }
        }
        .reviewPicture-modelImg {
            width: 100%;
            height: 100%;
            padding:44px 0;
            overflow: hidden;
            img {
                position: relative;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                -webkit-transform: translate(-50%,-50%);
                -moz-transform: translate(-50%,-50%);
                -o-transform: translate(-50%,-50%);
                -ms-transform: translate(-50%,-50%);
                max-width: 100%;
                max-height: 100%;
            }
        }
    }
</style>
